import { FEEDBACK_STATUSES, type FeedbackStatus } from '../../types/feedback';
import { FEEDBACK_STATUS_LABELS } from '../../utils/feedback-labels';

interface FeedbackStatusPanelProps {
  status: FeedbackStatus;
  disabled: boolean;
  isSaving: boolean;
  savingTo?: FeedbackStatus;
  onChange: (status: FeedbackStatus) => void;
}

export const FeedbackStatusPanel = ({
  status,
  disabled,
  isSaving,
  savingTo,
  onChange,
}: FeedbackStatusPanelProps) => (
  <div className="rounded-xl border border-black/10 bg-white p-6">
    <h3 className="text-sm font-semibold text-brand-blue mb-4">Status</h3>
    <label
      htmlFor="feedback-status"
      className="mb-2 block text-xs font-semibold uppercase tracking-wide text-text-grey"
    >
      Aktuell status
    </label>
    <select
      id="feedback-status"
      value={status}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value as FeedbackStatus)}
      className="w-full rounded-sm border border-black/10 bg-white px-3 py-2 text-sm text-brand-blue focus:border-brand-blue focus:outline-none disabled:opacity-50"
    >
      {FEEDBACK_STATUSES.map((option) => (
        <option key={option} value={option}>
          {FEEDBACK_STATUS_LABELS[option]}
        </option>
      ))}
    </select>
    <p className="mt-2 text-xs text-text-grey">
      {isSaving && savingTo
        ? `Uppdaterar till ${FEEDBACK_STATUS_LABELS[savingTo]}...`
        : 'Statusen sparas direkt och listan uppdateras.'}
    </p>
  </div>
);
